import { Box, Chip, Grid, Link, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CAppPaper from '../../../app/components/CAppPaper';
import AppFormatDate from '../../../app/features/format/AppFormatDate';
import AppCustomIcon from '../../../app/features/icon/AppIcon';
import INewsArticle from '../interfaces/INewsArticle';
import newsArticleLang from '../langs/langNewsArticle';
import styleVariables from '../../../app/styles/styleVariables';
import { sanitizeHtml } from '../../../app/utils/sanitizeHtml';

type CNewsArticleProps = {
	article: INewsArticle;
	size: 'small' | 'medium';
};

const CNewsArticle = (props: CNewsArticleProps) => {
	const { article, size } = props;

	const theme = useTheme();
	const { t } = useTranslation();

	return (
		<>
			{size === 'medium' ? (
				<CAppPaper
					id="news-article"
					variant="outlined"
					color="primary"
					displayBackgroundImage
					sx={{ padding: '20px' }}
				>
					<Grid container spacing={3} justifyContent="flex-start" alignItems="center">
						<Grid item sm={3} xs={4}>
							<Box
								sx={{
									width: '100%',
									backgroundImage: 'url(' + (article.image ?? '') + ')',
									backgroundSize: 'auto 100%',
									backgroundPosition: 'center center',
									backgroundRepeat: 'no-repeat',
									borderRadius: '10px',
									minHeight: '180px',
									margin: '0px',
								}}
							>
								&nbsp;
							</Box>
						</Grid>
						<Grid item sm={9} xs={8} style={{ height: '100%' }}>
							<div>
								{!!article.services.length && (
									<Chip
										color="primary"
										variant="outlined"
										label={article.services.join(', ')}
										sx={{
											fontSize: '0.85rem',
											backgroundColor: '#DFF5F5',
											color: theme.palette.primary.dark,
											border: '0px',
											padding: '2px 12px 0px',
										}}
									/>
								)}
							</div>
							<Box
								sx={{
									color: theme.palette.background.default,
									fontSize: '0.7rem',
									margin: '1rem 0px 0px',
								}}
							>
								<AppFormatDate date={article.creation} />
							</Box>
							<div
								style={{
									padding: '0.5rem 0px 1rem 0px',
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '1rem',
									lineHeight: '1.5',
								}}
							>
								<div
									dangerouslySetInnerHTML={{
										__html: sanitizeHtml(article.title), // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml -- sanitized via DOMPurify; CMS-authored news title
									}}
								/>
							</div>

							<div>
								<Link
									id="news-article-link"
									target="_blank"
									href={article.permalink}
									style={{
										textDecoration: 'none',

										fontFamily: "'Poppins'",
										fontStyle: 'normal',
										fontWeight: '500',
										fontSize: '15px',
										lineHeight: '22px',
										display: 'inline-block',
										color: 'white',
									}}
								>
									<AppCustomIcon tag="arrow-right" style={{ verticalAlign: 'middle' }} />{' '}
									{t(newsArticleLang.read.tag)}
								</Link>
							</div>
						</Grid>
					</Grid>
				</CAppPaper>
			) : (
				<CAppPaper id="news-article" variant="outlined" color="primary" sx={{ padding: '0px', margin: '0px' }}>
					<Box
						sx={{
							width: '100%',
							height: '100%',
							backgroundImage: 'url(' + (article.image ?? '') + ')',
							backgroundSize: 'cover',
							backgroundPosition: 'center center',
							backgroundRepeat: 'no-repeat',
							borderRadius: '10px',
							minHeight: '180px',
							margin: '0px',
							padding: '0px',
						}}
					>
						<Box
							sx={{
								width: '100%',
								height: '100%',
								backgroundColor: styleVariables.primaryColor + 'CC',

								borderRadius: '10px',
								minHeight: '180px',
								margin: '0px',
								padding: '20px',
								paddingTop: '90px',
							}}
						>
							<Grid container spacing={3} justifyContent="flex-start" alignItems="center">
								<Grid item sm={12} xs={8} style={{ height: '100%' }}>
									<div>
										{!!article.services.length && (
											<Chip
												color="primary"
												variant="outlined"
												label={article.services.join(', ')}
												sx={{
													fontSize: '0.85rem',

													backgroundColor: '#DFF5F5',
													color: theme.palette.primary.dark,
													border: '0px',
													padding: '2px 12px 0px',
												}}
											/>
										)}
									</div>
									<Box
										sx={{
											color: theme.palette.background.default,
											fontSize: '0.7rem',
											margin: '1rem 0px 0px',
										}}
									>
										<AppFormatDate date={article.creation} />
									</Box>
									<div
										style={{
											padding: '0.5rem 0px 1rem 0px',
											fontFamily: 'Poppins',
											fontWeight: '600',
											fontSize: '1rem',
											lineHeight: '1.5',
										}}
									>
										<div
											dangerouslySetInnerHTML={{
												__html: sanitizeHtml(article.title), // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml -- sanitized via DOMPurify; CMS-authored news title
											}}
										/>
									</div>

									<div>
										<Link
											id="news-article-link"
											target="_blank"
											href={article.permalink}
											style={{
												textDecoration: 'none',

												fontFamily: "'Poppins'",
												fontStyle: 'normal',
												fontWeight: '500',
												fontSize: '15px',
												lineHeight: '22px',
												display: 'inline-block',
												color: 'white',
											}}
										>
											<AppCustomIcon tag="arrow-right" style={{ verticalAlign: 'middle' }} />{' '}
											{t(newsArticleLang.read.tag)}
										</Link>
									</div>
								</Grid>
							</Grid>
						</Box>
					</Box>
				</CAppPaper>
			)}
		</>
	);
};

export default CNewsArticle;
